import type { ButtonSize } from '@timelyapp/react';
import { Button } from '@timelyapp/react';
import React from 'react';
import FontAwesome from 'react-fontawesome';

interface Props {
  testId: string;
  onClick: () => void;
  size?: ButtonSize;
}

const ClearFilterButton: React.FC<Props> = ({ testId, size, onClick }) => {
  return (
    <Button priority="low" size={size} onClick={onClick} data-testid={testId}>
      <FontAwesome name="times-circle" />
      <span>Clear filters</span>
    </Button>
  );
};

export default ClearFilterButton;
